import type { HistoricalBar } from '../services/api';

export type ValidHistoricalBar = HistoricalBar & {
  open: number;
  high: number;
  low: number;
  close: number;
};

export const isValidHistoricalBar = (bar: HistoricalBar): bar is ValidHistoricalBar =>
  Number.isFinite(bar.time)
  && [bar.open, bar.high, bar.low, bar.close].every(
    (value) => typeof value === 'number' && Number.isFinite(value),
  );
